import React from 'react';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';

/**
 * Custom hook that returns the columns configuration for a table.
 * @hook
 *
 * @returns {Object} An object containing the columns configuration.
 */
export const useColumns = () => {
  const { t } = useTranslation();
  const columns = [
    {
      title: t('mails.columns.error'),
      key: 'error',
      render: (data) =>
        data?.error ? (
          <CloseOutlined style={{ color: 'red' }} />
        ) : (
          <CheckOutlined style={{ color: 'green' }} />
        )
    },
    {
      title: t('mails.columns.from'),
      key: 'from',
      dataIndex: 'from',
      sorter: true,
      render: (from) => from?.email
    },
    {
      title: t('mails.columns.to'),
      key: 'to',
      render: (data) =>
        data?.to?.map((item) => (
          <p key={`${item?.name}-${item?.email}`}>{item?.email}</p>
        ))
    },
    {
      title: t('mails.columns.cc'),
      key: 'cc',
      render: (data) =>
        data?.cc?.map((item) => (
          <p key={`${item?.name}-${item?.email}`}>{item?.email}</p>
        ))
    },
    {
      title: t('mails.columns.subject'),
      key: 'subject',
      dataIndex: 'subject',
      render: (subject) => subject || '-'
    },
    {
      title: t('mails.columns.created_at'),
      key: 'created_at',
      dataIndex: 'created_at',
      render: (created_at) =>
        (created_at && dayjs(created_at).format('DD/MM/YYYY HH:mm')) || '-',
      sorter: true
    }
  ];
  return { columns };
};
